import updateWindowTitle from './update-window-title';
import cookiebot from '@/cookiebot';
import appInsights from '@/application-insights';
import { useNotificationsStore } from '@/stores/notification/notification';
import { useRootStore } from '@/stores/index';
import { useCodeTypeStore } from '@/stores/code-type/code-type';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';
import { initGtm } from '@/vue-gtm';

export default function (to, pinia) {
  const lang = to.meta?.lang ?? to.params?.lang;
  const aanbod = to.params?.aanbod;
  const aanvraagId = to.query?.aanvraagId;
  const notificationStore = useNotificationsStore(pinia);
  const rootStore = useRootStore(pinia);
  const codeTypeStore = useCodeTypeStore(pinia);
  const leadAanvraagStore = useLeadAanvraagStore(pinia);

  const configPromise = !rootStore.config.loaded
    ? rootStore.loadConfig().then(() => {
        appInsights.init(rootStore.config.instrumentationKey);

        if (rootStore.config.googleTagManagerContainer) {
          initGtm(rootStore.config.googleTagManagerContainer);
        }

        return Promise.resolve();
      })
    : Promise.resolve();

  configPromise
    .then(() => rootStore.handleRouteChangeLangChange(lang))
    .then(() => {
      if (rootStore.config.useCookiebot === 'true') {
        cookiebot.initialize(lang, to);
      }
    });

  if (rootStore.error) {
    rootStore.error = undefined;
  }

  if (to.meta.preLoadCodeTypeGroepnamen) {
    codeTypeStore.preLoadCodeTypeGroepnamen(to.meta.preLoadCodeTypeGroepnamen);
  }

  if (aanbod && aanvraagId) {
    leadAanvraagStore.loadFromRouteParams({
      lang,
      aanbod,
      aanvraagId,
      updatePrijzen: to.meta?.updatePrijzen
    });
  }

  notificationStore.forceClose();

  const windowTitle = updateWindowTitle(to);
  if (rootStore.config.loaded) {
    appInsights.trackRoutePageView(to, windowTitle);
  }
}
